
/**
 * 运行时定制信息
 */
export class DimensionInfo {
    /**
     * 第一维度
     */
    FirstDimension: string;

    FirstDimensionCode: string;

    FirstDimensionName: string;


    /**
     * 第二维度
     */
    SecondDimension: string;

    SecondDimensionCode: string;

    SecondDimensionName: string;
}


export function compareDimensionInfos(info1: DimensionInfo, info2: DimensionInfo): boolean {
    if(isEmptyStr(info1.FirstDimension) && 
       isEmptyStr(info2.FirstDimension) && 
       isEmptyStr(info1.SecondDimension) && 
       isEmptyStr(info2.SecondDimension)) {
        return true;
    }
    return (info1.FirstDimension == info2.FirstDimension &&
        info1.SecondDimension == info2.SecondDimension);
}

function isEmptyStr(s) {
	if (s == undefined || s == null || s == '') {
		return true
	}
	return false
}